import { ConfigServiceProvider } from '../config-service/config-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageServiceProvider } from '../storage-service/storage-service';

@Injectable()
export class UsersServiceProvider {
  private users: UserDisplay[];

  constructor(
    public http: HttpClient,
    private storageService: StorageServiceProvider,
    private configService: ConfigServiceProvider
  ) { }

  load() {
    return new Promise<void>((resolve, reject) => {
      this.http.get(this.configService.getUrl('users'))
        .toPromise()
        .then((response: UserDisplay[]) => {
          Object.keys(response).map((key, index) =>
            response[key].photo = response[key].photo === null ? 'assets/imgs/photo_placeholder.png' : response[key].photo
          );
          this.users = response;
          return this.storageService.setObject('users', response)
        }, (err) => reject(err))
        .then(() => resolve(),
          (err) => reject(err)
        );
    });
  }

  getChildren(userId?: number) {
    let url: string;
    if (userId) {
      url = this.configService.getUrl("userIdChildren").replace('{userId}', userId.toString());
    } else {
      url = this.configService.getUrl("userChildren");
    }
    return this.http.get<Array<any>>(url).toPromise();
  }

  getUsers(): Promise<UserDisplay[]> {
    return this.storageService.getObject('users');
  }

  getUsersProperty(): UserDisplay[] {
    return this.users;
  }
}

export interface User {
  activated: boolean,
  email: string,
  firstName: string,
  id: number,
  langKey: string,
  lastName: string,
  login: string,
  params: {
    role: string,
    type: string
  },
  photo: string,
  resetDate: Date,
  resetKey: string,
  userGroups: Array<{ userGroup: UserGroup }>
}

export interface UserGroup {
  functional: boolean,
  groupType: string,
  id: number,
  name: string,
  params: {
    groupType: string,
    parentId: number
  }
}

export enum UserType {
  PH = 'PH',
  ASM = 'ASM',
  RDS = 'RDS',
  VIP = 'VIP',
}

export interface UserDisplay {
  id: number,
  firstName: string,
  lastName: string,
  photo: string,
  userGroups: Array<{ userGroup: UserGroupId }>
}

export interface UserGroupId {
  id: number,
}



// WEBPACK FOOTER //
// ./src/modules/core/services/users-service/users-service.ts